const startPositionOptions = [
	{ id: '1', description: 'Standing' },
	{ id: '2', description: 'Sitting' },
	{ id: '3', description: 'Lying' },
	{ id: '4', description: 'Hanging' },
	{ id: '5', description: 'All fours' },
]

export default startPositionOptions
